import React from 'react'

import { RadBox } from '../common/RadBox'
import { RadButton } from '../common/RadButton'
import { RadContainer } from '../common/RadContainer'
import { RadCopyToClipboard } from '../common/RadCopyToClipboard'
import { RadExternalLink } from '../common/RadExternalLink'
import { RadGrid } from '../common/RadGrid'
import { RadHeader } from '../common/RadHeader'
import { RadLink } from '../common/RadLink'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { formatDate } from '../common/utilities'
import { ResourceFeedback } from './ResourceFeedback'
import { ReportBrokenLinkButton } from './ReportBrokenLinkButton'
import { RadDivider } from '../common/RadDivider'

export function ResourceDetailContent ({ resource, setSelectedEntity }) {
  return (
    <RadSpaceBetween size='l'>
      <RadSpaceBetween size='l'>
        <div>
          <RadBox variant='awsui-key-label' display='inline'>
            SECTOR(S):
          </RadBox>
          <RadBox variant='span' padding={{ left: 'xs' }}>
            {resource.sectors?.map(x => x.sector?.name).join(', ')}
          </RadBox>
        </div>
      </RadSpaceBetween>
      {
        resource.sourceId === 2 &&
          <RadContainer
            header={
              <RadHeader variant='h2'>
                Text
              </RadHeader>
            }
          >
            {resource.text}
          </RadContainer>
      }

      <RadGrid
        gridDefinition={[
          { colspan: { default: 12, xs: 8 } },
          { colspan: { default: 12, xs: 4 } }
        ]}
      >
        <div>
          <RadSpaceBetween size='s'>
            {resource.summary != null && <div>{resource.summary}</div>}
            {
          resource.sourceId === 0 &&
            <div>
              <RadBox variant='awsui-key-label'>
                File
              </RadBox>
              <div>
                {resource.file != null && <RadExternalLink href={resource.file} />}
              </div>
            </div>
        }
            {
          resource.sourceId === 1 &&
            <div>
              <RadBox variant='awsui-key-label'>
                Link
              </RadBox>
              <RadLink external externalIconAriaLabel='Opens in a new tab' href={resource.link} target='_blank'>{resource.link}</RadLink>
              <ReportBrokenLinkButton resource={resource} />
            </div>
        }

            <RadCopyToClipboard
              copyButtonText='Copy link'
              copyErrorText='Link failed to copy'
              copySuccessText='Link copied'
              textToCopy={`${window.location.origin}/resource/${resource.id}`}
            />

            <div />

            <div>
              <RadDivider className='light-green' />
              <RadBox variant='awsui-key-label'>
                Projects
              </RadBox>
              <div>{resource.projects?.length > 0
                ? resource.projects.map((x) =>
                  <div key={'project-' + x.id}>
                    {setSelectedEntity == null && <RadLink href={`/project/${x.project.id}`}>{x.project?.name}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'project', id: x.project.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.project?.name}
                      </RadButton>}
                  </div>
                )
                : '-'}
              </div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Collections
              </RadBox>
              <div>{resource.collections.length > 0
                ? resource.collections.map((x) =>
                  <div key={'collection-' + x.id}>
                    <RadButton
                      onClick={() => setSelectedEntity({ type: 'collection', id: x.collection.id })}
                      className='font-weight-400'
                      variant='inline-link'
                    >
                      {x.collection.name}
                    </RadButton>
                  </div>
                )
                : '-'}
              </div>
            </div>
          </RadSpaceBetween>
        </div>

        <RadContainer className='gray-background'>
          <RadSpaceBetween size='s'>
            <RadBox variant='h3'>
              Resource Details
            </RadBox>
            <div>
              <RadBox variant='awsui-key-label'>
                Type
              </RadBox>
              <RadBox padding={{ bottom: 'xxs' }}>
                {resource.type?.name ?? '-'}
              </RadBox>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Publisher
              </RadBox>
              <div>{resource.publisher ?? '-'}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Publication Date
              </RadBox>
              <div>{resource.publicationDate != null ? formatDate(resource.publicationDate) : '-'}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Author
              </RadBox>
              <div>{resource.author ?? '-'}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Priority Populations
              </RadBox>
              <div>{resource.targetPopulations?.length > 0 ? resource.targetPopulations.map((x) => <div key={x.id}>{x.targetPopulation.name}</div>) : '-'}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Project Types
              </RadBox>
              <div>{resource.useCases?.length > 0 ? resource.useCases.map((x) => <div key={x.id}>{x.useCase?.name}</div>) : '-'}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Framework Tags
              </RadBox>
              <div>{resource.tags.map(x => x.tag.name).join(', ')}</div>
            </div>
            <div>
              <RadBox variant='awsui-key-label'>
                Visibility<RadBox color='text-body-secondary' display='inline'>{resource.isPrivate === true ? ' (Private)' : ''}</RadBox>
              </RadBox>
              {resource.shares?.map((x) => <div key={x.id}><RadLink href={`/user/${x.user.id}`}>{x.user.name}</RadLink> - {x.allowEdit === false ? 'View only' : 'View and edit'}</div>)}
              {resource.isPrivate === false ? 'Public' : ''}
            </div>
          </RadSpaceBetween>
        </RadContainer>
      </RadGrid>
      <ResourceFeedback resource={resource} />
    </RadSpaceBetween>
  )
}
